module.exports = __webpack_public_path__ + "assets/Financial.251a58ea.svg";